<p-panel>
    <h4>Datos del producto de {{nameModule}}</h4>

    <app-reactive-form-builder
        (goBack)="goBack()"
        [form]="form.formFields"
        [id]="reactiveFormRecordId"
        [request]="request"
        [getRequest]="productApi.productos.GET">
    </app-reactive-form-builder>
</p-panel>
<br>
